export default __webpack_public_path__ + "static/media/3.106528f3.png";